import { render, staticRenderFns } from "./ShipmentsTableWeb.vue?vue&type=template&id=c194fb40&scoped=true"
import script from "./ShipmentsTableWeb.vue?vue&type=script&lang=js"
export * from "./ShipmentsTableWeb.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsTableWeb.vue?vue&type=style&index=0&id=c194fb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c194fb40",
  null
  
)

export default component.exports